var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "wrapper" }, [
    _c(
      "form",
      {
        staticClass: "make-person",
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.handleSubmit($event)
          }
        }
      },
      [
        _c("h4", [_vm._v("Add new person:")]),
        _vm._v(" "),
        _c(
          "label",
          { staticClass: "make-person__unit", attrs: { for: "first-name" } },
          [
            _vm._v("\n      First Name:\n      "),
            _c("input", {
              staticClass: "make-person__input",
              attrs: {
                type: "text",
                name: "firstName",
                id: "first-name",
                placeholder: "type text here"
              },
              on: { change: _vm.HandlerChangeTextInput }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "label",
          { staticClass: "make-person__unit", attrs: { for: "last-name" } },
          [
            _vm._v("\n      Last Name:\n      "),
            _c("input", {
              staticClass: "make-person__input",
              attrs: {
                type: "text",
                name: "lastName",
                id: "last-name",
                placeholder: "type text here"
              },
              on: { change: _vm.HandlerChangeTextInput }
            })
          ]
        ),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm.errors.length
          ? _c("p", [
              _c("b", [_vm._v("Пожалуйста исправьте указанные ошибки:")]),
              _vm._v(" "),
              _c(
                "ul",
                _vm._l(_vm.errors, function(error) {
                  return _c("li", { key: error }, [_vm._v(_vm._s(error))])
                }),
                0
              )
            ])
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "make-person__button", attrs: { type: "submit" } },
      [_c("span", { staticClass: "button__text" }, [_vm._v("Add person")])]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-155dc08e", { render: render, staticRenderFns: staticRenderFns })
  }
}